class Cart extends HTMLElement {
  constructor() {
    super();
    this.handleFormCheckbox();
    this.handleToggleDrawerCart();
    this.handleQuantityFields();
    this.handleAddToCart();
    this.handleDiscountCode();
    this.handleCartNote();
  }
  
  handleFormCheckbox() {
    const cartForm = document.querySelector(".js-drawer-cart-form");
    const submitBtn = document.querySelector(".js-drawer-cart-form button[type='submit']");

    if (!cartForm || !submitBtn) return;

    const checkboxes = cartForm.querySelectorAll("input[type='checkbox']");

    const updateState = () => {
      let hasInvalid = false;

      checkboxes.forEach(cb => {
        if (!cb.checkValidity()) hasInvalid = true;
      });

      cartForm.classList.toggle("has-invalid", hasInvalid);
    };

    checkboxes.forEach(cb => {
      cb.addEventListener("change", updateState);
      cb.addEventListener("input", updateState);
    });

    submitBtn.addEventListener("click", (e) => {
      updateState();
    });
  }

  closeDrawerCart() {
    const drawer = document.querySelector('.js-drawer-cart');
    if (!drawer || !drawer.classList.contains('display')) return;

    drawer.classList.add('closing');

    setTimeout(() => {
      drawer.classList.remove('active', 'closing', 'display');
    }, 300);
  }

  handleToggleDrawerCart() {
    const drawer = document.querySelector('.js-drawer-cart');
    if (!drawer) return;

    const openButtons = document.querySelectorAll('.js-open-drawer-cart');
    const closeButtons = document.querySelectorAll('.js-close-drawer-cart');

    openButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        if (drawer.classList.contains('active')) {
          this.closeDrawerCart();
        } 
        else {
          drawer.classList.add('display');
          setTimeout(() => drawer.classList.add('active'), 50);
        }
      });
    });

    closeButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeDrawerCart();
      });
    });

    document.addEventListener('click', (event) => {
      if (!drawer.classList.contains('active')) return;

      const target = event.target;

      if (drawer.contains(target)) return;

      if (target.closest('.js-open-drawer-cart')) return;

      this.closeDrawerCart();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.closeDrawerCart();
      }
    });
  }

  updateDrawerSavings(cart) {
    const savingsWrapper = document.querySelector('.js-drawer-cart-savings');
    const savingsBeforeEl = document.querySelector('.js-drawer-cart-savings-before');
    const savingsValueEl = document.querySelector('.js-drawer-cart-savings-value');
    const discountCodeEl = document.querySelector('.js-drawer-cart-discount-code');
    const discountInput = document.querySelector('.js-drawer-cart-discount-input');
    const applyBtn = document.querySelector('.js-change-drawer-cart-discount-code');
    const removeBtn = document.querySelector('.js-remove-drawer-cart-discount-code');

    if (!savingsWrapper || !savingsBeforeEl || !savingsValueEl || !cart) return;

    let savings = 0;

    if (Array.isArray(cart.items)) {
      cart.items.forEach((item) => {
        if (item.original_price && item.final_price && item.original_price > item.final_price) {
          const diff = item.original_price - item.final_price;
          const itemSaving = diff * item.quantity;
          savings += itemSaving;
        }
      });
    }

    let discountCodes = [];

    if (Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach((app) => {
        if (app.type === 'discount_code' && app.title) {
          discountCodes.push(app.title);
          if (applyBtn) applyBtn.classList.add('d-none');
          if (removeBtn) removeBtn.classList.remove('d-none');
        }
      });
    }

    if (Array.isArray(cart.items)) {
      cart.items.forEach((item) => {
        if (Array.isArray(item.line_level_discount_allocations)) {
          item.line_level_discount_allocations.forEach((allocation) => {
            const da = allocation.discount_application;
            if (da && da.type === 'discount_code' && da.title) {
              discountCodes.push(da.title);
              if (applyBtn) applyBtn.classList.add('d-none');
              if (removeBtn) removeBtn.classList.remove('d-none');
            }
          });
        }
      });
    }

    const uniqueCodes = [...new Set(discountCodes)];
    const discountCode = uniqueCodes.length ? uniqueCodes[uniqueCodes.length - 1] : '';

    if (discountInput) {
      if (discountCode !== '') {
        discountInput.value = discountCode;
      }
    }

    if (savings > 0) {
      const originalTotal = cart.total_price + savings;

      savingsWrapper.classList.remove('d-none');
      savingsBeforeEl.textContent = Shopify.formatMoney(originalTotal);
      savingsValueEl.textContent = '-' + Shopify.formatMoney(savings);

      if (discountCodeEl) {
        discountCodeEl.textContent = discountCode;
      }
    } else {
      savingsWrapper.classList.add('d-none');
      savingsBeforeEl.textContent = '';
      savingsValueEl.textContent = '';
      if (discountCodeEl) discountCodeEl.textContent = '';

      if (discountInput) {
        const lastTyped = discountInput.getAttribute("data-last-typed");
        if (lastTyped) discountInput.value = lastTyped;
      }
    }
  }

  handleQuantityFields() {
    const self = this;
    document.body.addEventListener('click', (event) => {
			const target = event.target.closest('.js-change-quantity');
			if (!target) return;

      event.preventDefault();
  
      target.classList.add('loading');
			  
			const variantId = parseInt(target.getAttribute('data-variant-id'), 10);
			let quantity = parseInt(target.getAttribute('data-quantity'), 10);
      const container = target.closest('.js-quantity-fields');

      container.querySelector('.js-quantity-minus').setAttribute('data-quantity', quantity - 1);
      container.querySelector('.js-quantity-plus').setAttribute('data-quantity', quantity + 1);

      const cartItem = container.closest('.js-cart-item');
      cartItem.style.height = `${cartItem.offsetHeight}px`;
			  
      var formData = new FormData();
      formData.append("updates[" + variantId + "]", quantity);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(response => {
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
				const subtotalElement = document.querySelector('.js-subtotal-price');
				if (subtotalElement) {
					subtotalElement.innerHTML = Shopify.formatMoney(response.total_price);
				}

        self.updateDrawerSavings(response);
        
        if (quantity < 1) {
          cartItem.classList.add('hide-item');
          setTimeout(() => {
            cartItem.classList.add('hidden');
            if (response.total_price === 0) {
              document.querySelector('.js-cart-content').classList.add('drawer-cart__content--empty');
            }
          }, 300);
        } else {
          container.querySelector('.js-quantity-field-input').value = quantity;
        }

        document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
          cartCounter.innerHTML = response.item_count;
          cartCounter.setAttribute('data-counter', response.item_count);
        });
      })
      .catch(error => {
        alert(error.message || 'Error');
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
      });
    });
  }

  handleAddToCart() {
    const self = this;
		document.body.addEventListener("click", function (event) {
      const target = event.target.closest(".js-add-to-cart");
	    if (!target) return;

	    event.preventDefault();

      if (!target.classList.contains('js-add-to-cart-2')) {
        target.getAttribute("data-adding-text") && (target.innerHTML = target.getAttribute("data-adding-text"));
        target.classList.add("loading");
      }

	    let quantity, id = {};

      let productId = target.getAttribute("data-product-id");
      let productElement = document.querySelector(`.js-product[data-product-id='${productId}'], .js-product-grid-item[data-product-id='${productId}']`);
      quantity = productElement?.querySelector(".js-quantity-field")?.value || 1;
      if (isNaN(quantity) || !quantity) quantity = 1;
      id = productElement ? productElement.querySelector(`#product-select-${productId}`).value : target.getAttribute("data-variant-id");

      let image = target.getAttribute("data-featured-image") || response.image;

      let formData = {
       'items': [{
          'id': parseInt(id, 10),
          'quantity': parseInt(quantity, 10)
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.description || 'Something went wrong');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .then(response => {
        response = response.items.find(item => item.id === parseInt(id, 10));
        let variantId = response.variant_id;
        let cartItem = document.querySelector(`.js-cart-item[data-variant-id='${variantId}']:not(.hidden)`);

        if (cartItem) {
          let quantityField = cartItem.querySelector(".js-quantity-field-input");
          let quantityMinus = cartItem.querySelector(".js-quantity-minus");
          let quantityPlus = cartItem.querySelector(".js-quantity-plus");

          quantityField.value = response.quantity;
          quantityMinus.setAttribute("data-quantity", response.quantity - 1);
          quantityPlus.setAttribute("data-quantity", response.quantity + 1);
        } else {
          let quantityMinus = response.quantity - 1;
          let quantityPlus = response.quantity + 1;
          if(response.image) {
            const img = new Image();
            img.src = response.image;
          }

          let item = `
            <li class="js-cart-item js-quantity-fields" data-variant-id="${response.variant_id}">
              <div class="cart-item d-flex">
                <div class="cart-item__image">
                  <a href="${response.url}">
                    <img src="${image}" width="668" height="768" alt="${response.product_title}">
                  </a>
                </div>

                <div class="cart-item__details">
                  <div class="cart-item__title">
                    <a href="${response.url}">${response.product_title}</a>
                  </div>
                </div>

                <div class="cart-item__delete">
                  <a href="#"
                     class="js-change-quantity"
                     data-variant-id="${response.variant_id}"
                     data-quantity="0">
                    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.99333 17.716L7.98417 17.7177L7.925 17.7468L7.90833 17.7502L7.89667 17.7468L7.8375 17.7177C7.82861 17.7149 7.82194 17.7163 7.8175 17.7218L7.81417 17.7302L7.8 18.0868L7.80417 18.1035L7.8125 18.1143L7.89917 18.176L7.91167 18.1793L7.92167 18.176L8.00833 18.1143L8.01833 18.101L8.02167 18.0868L8.0075 17.731C8.00528 17.7221 8.00056 17.7171 7.99333 17.716ZM8.21417 17.6218L8.20333 17.6235L8.04917 17.701L8.04083 17.7093L8.03833 17.7185L8.05333 18.0768L8.0575 18.0868L8.06417 18.0927L8.23167 18.1702C8.24222 18.173 8.25028 18.1707 8.25583 18.1635L8.25917 18.1518L8.23083 17.6402C8.22806 17.6302 8.2225 17.6241 8.21417 17.6218ZM7.61833 17.6235C7.61466 17.6213 7.61027 17.6206 7.60608 17.6215C7.60189 17.6224 7.59822 17.6249 7.59583 17.6285L7.59083 17.6402L7.5625 18.1518C7.56306 18.1618 7.56778 18.1685 7.57667 18.1718L7.58917 18.1702L7.75667 18.0927L7.765 18.086L7.76833 18.0768L7.7825 17.7185L7.78 17.7085L7.77167 17.7002L7.61833 17.6235Z" fill="#B31236"/>
                      <path d="M9.4 4.83491e-08C9.7498 9.07165e-05 10.0907 0.110238 10.3744 0.31484C10.6581 0.519442 10.8703 0.808125 10.9808 1.14L11.4333 2.5H14.1667C14.3877 2.5 14.5996 2.5878 14.7559 2.74408C14.9122 2.90036 15 3.11232 15 3.33333C15 3.55435 14.9122 3.76631 14.7559 3.92259C14.5996 4.07887 14.3877 4.16667 14.1667 4.16667L14.1642 4.22583L13.4417 14.345C13.3966 14.9755 13.1143 15.5655 12.6517 15.9963C12.1891 16.4271 11.5805 16.6666 10.9483 16.6667H4.05167C3.41955 16.6666 2.81092 16.4271 2.34831 15.9963C1.88569 15.5655 1.60342 14.9755 1.55833 14.345L0.835833 4.225L0.833333 4.16667C0.61232 4.16667 0.400358 4.07887 0.244078 3.92259C0.0877973 3.76631 0 3.55435 0 3.33333C0 3.11232 0.0877973 2.90036 0.244078 2.74408C0.400358 2.5878 0.61232 2.5 0.833333 2.5H3.56667L4.01917 1.14C4.12975 0.80799 4.34203 0.51921 4.62592 0.314596C4.9098 0.109982 5.25089 -8.42177e-05 5.60083 4.83491e-08H9.4ZM12.4975 4.16667H2.5025L3.22083 14.2258C3.23579 14.436 3.32981 14.6327 3.48397 14.7763C3.63812 14.92 3.84096 14.9999 4.05167 15H10.9483C11.159 14.9999 11.3619 14.92 11.516 14.7763C11.6702 14.6327 11.7642 14.436 11.7792 14.2258L12.4975 4.16667ZM5.83333 6.66667C6.03744 6.66669 6.23445 6.74163 6.38698 6.87726C6.53951 7.0129 6.63695 7.19979 6.66083 7.4025L6.66667 7.5V11.6667C6.66643 11.8791 6.5851 12.0834 6.43929 12.2378C6.29349 12.3923 6.09421 12.4852 5.88217 12.4976C5.67014 12.5101 5.46135 12.4411 5.29847 12.3048C5.1356 12.1685 5.03092 11.9751 5.00583 11.7642L5 11.6667V7.5C5 7.27899 5.0878 7.06703 5.24408 6.91074C5.40036 6.75446 5.61232 6.66667 5.83333 6.66667ZM9.16667 6.66667C9.38768 6.66667 9.59964 6.75446 9.75592 6.91074C9.9122 7.06703 10 7.27899 10 7.5V11.6667C10 11.8877 9.9122 12.0996 9.75592 12.2559C9.59964 12.4122 9.38768 12.5 9.16667 12.5C8.94565 12.5 8.73369 12.4122 8.57741 12.2559C8.42113 12.0996 8.33333 11.8877 8.33333 11.6667V7.5C8.33333 7.27899 8.42113 7.06703 8.57741 6.91074C8.73369 6.75446 8.94565 6.66667 9.16667 6.66667ZM9.4 1.66667H5.6L5.3225 2.5H9.6775L9.4 1.66667Z" fill="#B31236"/>
                    </svg>
                  </a>
                </div>
              </div>

              ${
                (response.options_with_values || [])
                  .filter(option => option.name !== 'Title')
                  .map(option => `
                    <div class="cart-item__option d-flex align-items-center">
                      <div class="option-name">${option.name}</div>
                      <div class="option-value">${option.value}</div>
                    </div>
                  `)
                  .join('')
              }

              <div class="cart-product__quantity-and-price d-flex align-items-center">
                <div class="cart-item__price">
                  ${Shopify.formatMoney(response.final_price)}
                </div>

                <div class="cart-product__quantity-field">
                  <div class="quantity-field__minus">
                    <a href="#"
                       class="js-change-quantity js-quantity-minus"
                       data-variant-id="${response.variant_id}"
                       data-quantity="${response.quantity - 1}">
                      <svg width="15" height="2" viewBox="0 0 15 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99431 10.216L7.98514 10.2177L7.92598 10.2468L7.90931 10.2502L7.89764 10.2468L7.83848 10.2177C7.82959 10.2149 7.82292 10.2163 7.81848 10.2218L7.81514 10.2302L7.80098 10.5868L7.80514 10.6035L7.81348 10.6143L7.90014 10.676L7.91264 10.6793L7.92264 10.676L8.00931 10.6143L8.01931 10.601L8.02264 10.5868L8.00848 10.231C8.00625 10.2221 8.00153 10.2171 7.99431 10.216ZM8.21514 10.1218L8.20431 10.1235L8.05014 10.201L8.04181 10.2093L8.03931 10.2185L8.05431 10.5768L8.05848 10.5868L8.06514 10.5927L8.23264 10.6702C8.2432 10.673 8.25125 10.6707 8.25681 10.6635L8.26014 10.6518L8.23181 10.1402C8.22903 10.1302 8.22348 10.1241 8.21514 10.1218ZM7.61931 10.1235C7.61564 10.1213 7.61125 10.1206 7.60706 10.1215C7.60286 10.1224 7.59919 10.1249 7.59681 10.1285L7.59181 10.1402L7.56348 10.6518C7.56403 10.6618 7.56875 10.6685 7.57764 10.6718L7.59014 10.6702L7.75764 10.5927L7.76598 10.586L7.76931 10.5768L7.78348 10.2185L7.78098 10.2085L7.77264 10.2002L7.61931 10.1235Z" fill="#B31236"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.833333C0 0.61232 0.0877973 0.400358 0.244078 0.244078C0.400358 0.0877975 0.61232 0 0.833333 0H14.1667C14.3877 0 14.5996 0.0877975 14.7559 0.244078C14.9122 0.400358 15 0.61232 15 0.833333C15 1.05435 14.9122 1.26631 14.7559 1.42259C14.5996 1.57887 14.3877 1.66667 14.1667 1.66667H0.833333C0.61232 1.66667 0.400358 1.57887 0.244078 1.42259C0.0877973 1.26631 0 1.05435 0 0.833333Z" fill="#B31236"/>
                      </svg>
                    </a>
                  </div>

                  <input type="text"
                         value="${response.quantity}"
                         class="quantity-field__input js-quantity-field-input"
                         disabled="disabled" />

                  <div class="quantity-field__plus">
                    <a href="#"
                       class="js-change-quantity js-quantity-plus"
                       data-variant-id="${response.variant_id}"
                       data-quantity="${response.quantity + 1}">
                      <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.99431 16.8801L7.98514 16.8817L7.92598 16.9109L7.90931 16.9142L7.89764 16.9109L7.83848 16.8817C7.82959 16.879 7.82292 16.8803 7.81848 16.8859L7.81514 16.8942L7.80098 17.2509L7.80514 17.2676L7.81348 17.2784L7.90014 17.3401L7.91264 17.3434L7.92264 17.3401L8.00931 17.2784L8.01931 17.2651L8.02264 17.2509L8.00848 16.8951C8.00625 16.8862 8.00153 16.8812 7.99431 16.8801ZM8.21514 16.7859L8.20431 16.7876L8.05014 16.8651L8.04181 16.8734L8.03931 16.8826L8.05431 17.2409L8.05848 17.2509L8.06514 17.2567L8.23264 17.3342C8.2432 17.337 8.25125 17.3348 8.25681 17.3276L8.26014 17.3159L8.23181 16.8042C8.22903 16.7942 8.22348 16.7881 8.21514 16.7859ZM7.61931 16.7876C7.61564 16.7853 7.61125 16.7846 7.60706 16.7856C7.60286 16.7865 7.59919 16.789 7.59681 16.7926L7.59181 16.8042L7.56348 17.3159C7.56403 17.3259 7.56875 17.3326 7.57764 17.3359L7.59014 17.3342L7.75764 17.2567L7.76598 17.2501L7.76931 17.2409L7.78348 16.8826L7.78098 16.8726L7.77264 16.8642L7.61931 16.7876Z" fill="#B31236"/>
                        <path d="M6.66667 14.1667C6.66667 14.3877 6.75446 14.5996 6.91074 14.7559C7.06702 14.9122 7.27899 15 7.5 15C7.72101 15 7.93297 14.9122 8.08926 14.7559C8.24554 14.5996 8.33333 14.3877 8.33333 14.1667V8.33333H14.1667C14.3877 8.33333 14.5996 8.24554 14.7559 8.08926C14.9122 7.93297 15 7.72101 15 7.5C15 7.27899 14.9122 7.06702 14.7559 6.91074C14.5996 6.75446 14.3877 6.66667 14.1667 6.66667H8.33333V0.833333C8.33333 0.61232 8.24554 0.400358 8.08926 0.244078C7.93297 0.0877973 7.72101 0 7.5 0C7.27899 0 7.06702 0.0877973 6.91074 0.244078C6.75446 0.400358 6.66667 0.61232 6.66667 0.833333V6.66667H0.833333C0.61232 6.66667 0.400358 6.75446 0.244078 6.91074C0.0877973 7.06702 0 7.27899 0 7.5C0 7.72101 0.0877973 7.93297 0.244078 8.08926C0.400358 8.24554 0.61232 8.33333 0.833333 8.33333H6.66667V14.1667Z" fill="#B31236"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </li>
          `;
          document.querySelector(".js-cart-items").insertAdjacentHTML("beforeend", item);
          if (typeof initializeFadeInObserver === "function") {
            initializeFadeInObserver(document);
          }
        }

        return fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
	    })
	    .then(cart => {
        self.updateDrawerSavings(cart);
        document.querySelectorAll(".js-change-quantity").forEach(el => el.classList.remove("loading"));
				const subtotalElement = document.querySelector('.js-subtotal-price');
				if (subtotalElement) {
					subtotalElement.innerHTML = Shopify.formatMoney(cart.total_price);
				}
        document.querySelector(".js-cart-content")?.classList.remove("drawer-cart__content--empty");
        document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
          cartCounter.innerHTML = cart.item_count;
          cartCounter.setAttribute('data-counter', cart.item_count);
        });
        document.querySelector('.js-drawer-cart')?.classList.add('display');
        setTimeout(() => {
          document.querySelector('.js-drawer-cart')?.classList.add('active');
        }, 50);
        document.querySelectorAll('.js-add-to-cart:not(.js-add-to-cart-2)').forEach(button => {
          const originalText = button.getAttribute('data-original-text');
          button.textContent = originalText;
        });
	    })
      .catch(async (error) => {
        let message = 'Unexpected error';

        try {
          const text = await error.text();
          const json = JSON.parse(text);
          if (json && json.description) {
            message = json.description;
          }
        } catch (e) {
          message = error.message || 'Something went wrong';
        }

        alert(message);
        window.location.reload();
      });
		});
  }

  handleDiscountCode() {
    const self = this;
    const input = document.querySelector(".js-drawer-cart-discount-input");
    const applyBtn = document.querySelector(".js-change-drawer-cart-discount-code");
    const removeBtn = document.querySelector(".js-remove-drawer-cart-discount-code");

    const setAppliedState = () => {
      if (applyBtn) applyBtn.classList.add("d-none");
      if (removeBtn) removeBtn.classList.remove("d-none");
    };

    const setClearedState = () => {
      if (input) input.value = "";
      if (applyBtn) applyBtn.classList.add("d-none");
      if (removeBtn) removeBtn.classList.add("d-none");
    };

    if (input && applyBtn) {
      input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
          applyBtn.classList.remove("d-none");
        } else {
          applyBtn.classList.add("d-none");
        }
      });

      applyBtn.addEventListener("click", async (e) => {
        e.preventDefault();

        const code = input.value.trim();
        if (!code) return;

        input.setAttribute("data-last-typed", code);

        applyBtn.classList.add("loading");

        try {
          await fetch(`/checkout?discount=${encodeURIComponent(code)}`, {
            method: "GET",
            mode: "no-cors",
            credentials: "include"
          });
        } catch (err) {
          console.warn("Error calling /checkout?discount=CODE", err);
        }

        try {
          const res = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await res.json();
          self.updateDrawerSavings(cart);

          const subtotalElement = document.querySelector('.js-subtotal-price');
          if (subtotalElement) {
            subtotalElement.innerHTML = Shopify.formatMoney(cart.total_price);
          }

          setAppliedState();
        } catch (err) {
          console.warn("Error refreshing cart after applying discount", err);
        } finally {
          applyBtn.classList.remove("loading");
        }
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        removeBtn.classList.add("loading");

        try {
          await fetch('/checkout?discount=CLEAR', {
            method: 'GET',
            mode: 'no-cors',
            credentials: 'include'
          });
        } catch (err) {
          console.warn("Error calling /checkout?discount=CLEAR", err);
        }

        try {
          const res = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await res.json();
          self.updateDrawerSavings(cart);

          const subtotalElement = document.querySelector('.js-subtotal-price');
          if (subtotalElement) {
            subtotalElement.innerHTML = Shopify.formatMoney(cart.total_price);
          }

          setClearedState();
        } catch (err) {
          console.warn("Error refreshing cart after removing discount", err);
        } finally {
          removeBtn.classList.remove("loading");
        }
      });
    }
  }

  handleCartNote() {
    const wrapper = document.querySelector('.js-drawer-cart-note-wrapper');
    const textarea = document.querySelector('.js-drawer-cart-note');
    const formNote = document.querySelector('.js-drawer-cart-form-note');

    if (!wrapper || !textarea || !formNote) return;

    wrapper.addEventListener('click', () => {
      wrapper.classList.add('active');
      textarea.focus();
    });

    const syncNote = () => {
      formNote.value = textarea.value;
    };

    textarea.addEventListener('input', syncNote);
    textarea.addEventListener('change', syncNote);
  }
}

customElements.define('drawer-cart', Cart);